export default "__VITE_ASSET__CYplId0U__"